export default {
  items: []
}



// WEBPACK FOOTER //
// ./src/store/modules/accessories/state.js